module.exports = __webpack_public_path__ + "static/media/rest3.3862ab82.webp";